const grey800Color = '#797979';

export default grey800Color;
